import React, { Component } from 'react'
import UserActions from '../actions/UserActions'
import UserStore from '../stores/UserStore'
import ReactCaptcha from '../components/captcha/ReactCaptcha';
import { Form, Overlay, Popover, Button } from 'react-bootstrap'
import LoaderButton from './LoaderButton'
import { Link } from 'react-router'
import SessionActions from '../actions/SessionActions'
import SessionStore from '../stores/SessionStore'
import '../styles/Login.css'
import HandleException from '../utils/HandleException'
import ErrorStore from '../stores/ErrorStore'
import VersionStore from '../stores/VersionStore'
import VersionActions from '../actions/VersionActions'
import LogoImg from './LogoImg';

const passwordMsg = 'password is required (minimum is 6 characters).'
const emailRequired = 'email is required.'
const captchaFailed = 'captcha verification failed.'
export default class SignupBusiness extends Component {
  constructor(props) {
    super(props)
    this.emailRef = target => this.setState({ emailState: target })
    this.passwordRef = target => this.setState({ passwordState: target })
    this.captchaRef = target => this.setState({ captchaState: target })
    this.state = {
      email: '',
      password: '',
      isLoading: false,
      validationMessage: {}
    }
    this.onNew = this.onNew.bind(this)
    this.onFeedback = this.onFeedback.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.valdateFormForLogin = this.valdateFormForLogin.bind(this)
    this.handleChangePassword = this.handleChangePassword.bind(this)
    this.handleChangeEmail = this.handleChangeEmail.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleLogin = this.handleLogin.bind(this)
    this.onLogin = this.onLogin.bind(this)
    this.redirectToContents = this.redirectToContents.bind(this)
    this.onError = this.onError.bind(this)
    this.container = React.createRef()
    this.componentId = 'signupbusiness'
    this.onChangeVersion = this.onChangeVersion.bind(this)
    this.captchaMatched = false
    this.handleSuccess = this.handleSuccess.bind(this)
    this.handleFailure = this.handleFailure.bind(this)
  }

  componentDidMount() {
    VersionActions.receiveVersion();
  }

  UNSAFE_componentWillMount() {
    UserStore.addNewListener(this.onNew)
    UserStore.addFeedbackListener(this.onFeedback)
    SessionStore.addLoginListener(this.onLogin)
    ErrorStore.addErrorListener(this.onError)
    VersionStore.addChangeListener(this.onChangeVersion)
    VersionStore.removeChangeListener(this.onChangeVersion)
  }

  componentWillUnmount() {
    UserStore.removeNewListener(this.onNew)
    UserStore.removeFeedbackListener(this.onFeedback)
    SessionStore.removeLoginListener(this.onLogin)
    ErrorStore.removeErrorListener(this.onError)
  }

  onFeedback() {
    var feedback = UserStore.getFeedback()
    if (feedback.hasOwnProperty('email') ||
      feedback.hasOwnProperty('password')) {
      var val = this.state.validationMessage
      val['email'] = feedback['email']
      val['password'] = feedback['password']
      this.setState({ validationMessage: val }, function () {
        var validation_two = (this.state.validationMessage['email'] === '' && this.state.password.length > 5 && this.captchaMatched == true)
        if (validation_two === true) {
          this.setState({ isLoading: true })
          UserActions.saveBusinessUser(this.componentId, this.state)
        }
      })
    } else {
      var message = feedback.hasOwnProperty('description') ? feedback.description : feedback
      alert(message)
      this.setState({ isLoading: false })
    }
  }

  onNew() {
    SessionActions.saveSession(this.componentId, this.state)
  }

  onLogin() {
    this.redirectToContents()
  }

  valdateFormForLogin() {
    this.setMsg('email', '')
    this.setMsg('password', '')
    this.setMsg('captcha', '')
    if (this.state.email.length === 0) this.setMsg('email', emailRequired)
    if (this.state.password.length === 0) this.setMsg('password', passwordMsg)
    if (this.captchaMatched == false) this.setMsg('captcha', captchaFailed)
    return (this.state.validationMessage['email'] === '' && this.state.password.length > 5)
  }

  validateForm() {
    this.setMsg('email', '')
    this.setMsg('password', '')
    this.setMsg('captcha', '')
    if (this.state.email.length == 0) this.setMsg('email', emailRequired)
    if (this.state.password.length < 6) this.setMsg('password', passwordMsg)
    if (this.captchaMatched == false) this.setMsg('captcha', captchaFailed)
    var validation_one = (this.state.validationMessage['email'] === '' && this.state.password.length > 5 && this.captchaMatched == true)
    if (validation_one === true) {
      UserActions.verifyEmail(this.componentId, this.state.email)
    }
  }

  setMsg(field, msg) {
    var val = this.state.validationMessage
    val[field] = msg
    this.setState({ validationMessage: val })
  }

  handleChangeEmail(event) {
    this.setState({ [event.target.id]: event.target.value })
    event.target.value.trim().length == 0 ? this.setMsg('email', emailRequired) : this.setMsg('email', '')
  }

  handleChangePassword(event) {
    this.setState({ [event.target.id]: event.target.value })
    event.target.value.length < 6 ? this.setMsg('password', passwordMsg) : this.setMsg('password', '')
  }

  handleSubmit() {
    this.validateForm()
  }

  handleLogin() {
    if (this.valdateFormForLogin()) {
      SessionActions.saveSession(this.componentId, this.state)
    }
  }

  redirectToContents() {
    if (SessionStore.getLogged()) {
      this.props.route.history.push({ pathname: 'contents' });
    }
  }

  onError(source, error) {
    if (source == this.componentId) {
      HandleException.handle_error(error);
    }
  }

  onChangeVersion() {
    window.location.reload(true)
  }


  handleSuccess = () => {
    this.captchaMatched = true;
  }

  handleFailure = () => {
    this.captchaMatched = false;
  }

  render() {
    return (
      <div className='Login' ref={this.container}>
        <div className='signupbusiness-form'>
          <div className='Login text-center'>
            <div className='card'>
              <LogoImg />
              <div className='signal34-welcome'>
                Welcome to Signal34
              </div>
              <div className='signal34-grow'>
                Grow your business
              </div>
              <div className='center-text-signup' />
              <Form className='signal34-form'>
                <Form.Group controlId='email'>
                  <Form.Control autoFocus type='email' value={this.state.email} onChange={this.handleChangeEmail} placeholder='Email' ref={this.emailRef} autoComplete='username' />
                  <Overlay show={this.state.validationMessage['email'] !== undefined && this.state.validationMessage['email'] !== ''} target={this.state.emailState} placement='right' container={() => this.container.current} containerPadding={20} >
                    <Popover id='popover-email'>
                      <Popover.Body>
                        {this.state.validationMessage['email']}
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </Form.Group>

                <Form.Group controlId='password'>
                  <Form.Control value={this.state.password} onChange={this.handleChangePassword} type='password' placeholder='Create a Password' ref={this.passwordRef} autoComplete='new-password' />
                  <Overlay show={this.state.validationMessage['password'] !== undefined && this.state.validationMessage['password'] !== ''} target={this.state.passwordState} placement='right' container={() => this.container.current} containerPadding={20} >
                    <Popover id='popover-password' >
                      <Popover.Body>
                        {this.state.validationMessage['password']}
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </Form.Group>

                <div className='signal34-recaptcha' ref={this.captchaRef}>
                  <ReactCaptcha charset='ul' length={5} color='#5a5a5a' reload handleSuccess={this.handleSuccess} handleFailure={this.handleFailure} />
                  <Overlay show={this.state.validationMessage['captcha'] !== undefined && this.state.validationMessage['captcha'] !== ''} target={this.state.captchaState} placement='right' container={() => this.container.current} containerPadding={20} >
                    <Popover id='popover-captcha' >
                      <Popover.Body>
                        {this.state.validationMessage['captcha']}
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </div>
                <div className='signal34-blue-button'>
                  <LoaderButton className="signal34-bnt-primary" variant="primary" onClick={this.handleSubmit} isLoading={this.state.isLoading}
                    text='Create Account' loadingText='Creating account...' />
                </div>
                <div className='signal34-ten'>
                </div>
                <div className='signal34-gray-button' >
                  <Button onClick={this.handleLogin} variant="outline-secondary">Log in</Button>
                </div>
              </Form>
              <div className='signal34-continuing'>
                By continuing you agree to Signal34&#39;s <span><a target='_blank' href='./business_terms_of_service'>Business</a></span>
              </div>
              <div className='signal34-continuing'>
                <span><a target='_blank' href='./business_terms_of_service'>Terms of Service</a></span> and <span><a target='_blank' href='./privacy_policy'>Privacy Policy</a></span>
              </div>

              <div className='signal34-middle-bold create-personal' >
                <Link to={'/signup'}><span>Create a personal account </span></Link>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div className='text-center small copyright signal34-footer'>
            <div>
              <span> © 2019 Signal34 </span> | <a target='_blank' href='./about'>About</a> | <Link to={'/'}>Home</Link> | <Link to={'/signup'}>Sign Up</Link> | <a target='_blank' href='./howto'>HowTo</a> | <a target='_blank' href='./business_terms_of_service'>Terms of Service</a> | <a target='_blank' href='./privacy_policy'>Privacy policy</a>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}
